import { render, staticRenderFns } from "./OrderConflict.vue?vue&type=template&id=3be0835c&scoped=true&"
import script from "./OrderConflict.vue?vue&type=script&lang=ts&"
export * from "./OrderConflict.vue?vue&type=script&lang=ts&"
import style0 from "./OrderConflict.vue?vue&type=style&index=0&id=3be0835c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be0835c",
  null
  
)

export default component.exports